<template>
	<div v-if="!['left-align', 'oversize-left'].includes(block.content.alignment)">
		<client-only-wrapper>
			<div :class="`image-block image-block--${block.content.alignment}`">
				<post-pinterest @click="sharePinterest" />
				<!-- eslint-disable-next-line -->
				<img
					:alt="block.content.caption"
					:src="block.content.media.url"
				/>
			</div>

			<caption
				v-if="block.content.caption"
				class="image-block__caption"
			>
				<a
					v-if="block.content.caption_link"
					target="_blank"
					:href="block.content.caption_link"
				>
					{{ block.content.caption }}
				</a>
				<template v-else>
					{{ block.content.caption }}
				</template>
			</caption>
		</client-only-wrapper>
	</div>
</template>
<script>
import PostPinterest from '../../post-pinterest/PostPinterest.vue';
import ClientOnlyWrapper from '../../../client-only-wrapper/ClientOnlyWrapper.vue';

export default {
	components: {
		PostPinterest,
		ClientOnlyWrapper,
	},
	props: {
		block: {
			type: Object,
			required: true,
		},
		next: {
			type: Object,
			required: false,
			default: null,
		},
	},
	methods: {
		sharePinterest() {
			this.$parent.$emit('imageClick', this.block.content.media.url);
		},
	},
};
</script>

<style lang="scss" src="./image-block.scss" />
